<template>
  <div>
    <back-btn />
    <v-container>
      <v-row>
        <v-col>
          <create-form @submitForm="submitData" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <list :datas="datas"></list>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import List from "@/components/dots/DotsActivity/List.vue";
import CreateForm from "@/components/dots/DotsActivity/CreateForm.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  created() {
    this.$store.dispatch("DotsActivity/getAll", {
      dots_patient_id: this.$route.params.id,
    });
  },
  computed: {
    ...mapState("DotsActivity", ["datas"]),
  },
  components: {
    List,
    CreateForm,
    BackBtn,
  },
  methods: {
    submitData(data) {
      if (!this.datas.slice(-1)[0].dots_enddate) {
        this.$toast.error("Your Last DOTS Activity is not finished");
      } else if (
        new Date(data.dots_startdate) <
        new Date(this.datas.slice(-1)[0].dots_enddate)
      ) {
        this.$toast.error(
          "DOTS Startdate should be larger than last dots enddate"
        );
      } else {
        this.$store.dispatch("DotsActivity/save", {
          dots_patient_id: this.$route.params.id,
          dots_startdate: data.dots_startdate,
          volunteer_id: data.volunteer_id,
          dots_app_status: data.dots_app_status,
        });
      }
    },
  },
};
</script>

<style></style>
